module.exports = __webpack_public_path__ + "img/banner_en.f81bcbfc.png";